module.exports = __webpack_public_path__ + "img/wm-system-demo2.805fb688.png";